import { message, notification } from 'antd'
// export const BASE_URL = "https://bamrec-api.herokuapp.com/api/";
export const BASE_URL =
  'https://bamrec-staging-api-6c60736d4dac.herokuapp.com/api/';

export const successMessage = (message = 'Success') => {
  notification.success({
    message,
  })
}
export const failureMessage = (message = 'failure') => {
  notification.error({
    message,
  })
}
export const infoMessage = (message = 'info') => {
  notification.info({
    message,
  })
}
